import { Navigate, Route, Routes } from 'react-router-dom'
import Layout from '../Components/Layout/Layout'
import Login from '../Components/auth/Login'
import Otp from '../Components/auth/Otp'
import PrivateRoute from './PrivateRoutes'
import { useSelector } from 'react-redux';
import { RootState } from '../global/config/store'
import ProtectedRoutes from './ProtectedRoutes'
import { routeConfig } from './routeConfig'


const Approutes = () => {
    const token = useSelector((state: RootState) => state.auth.token);

    return (
        <Routes>
            <Route path='/' element={token ? <Navigate to="/admin/dashboard" replace /> : <Login />} />
            <Route
                path='/otp'
                element={
                    <ProtectedRoutes>
                        <Otp />
                    </ProtectedRoutes>
                }
            />
            {routeConfig.map((route) => (
                <Route
                    key={route.path}
                    path={route.path}
                    element={
                        <Layout>
                            <PrivateRoute>
                                {route.element}
                            </PrivateRoute>
                        </Layout>
                    }
                />
            ))}
        </Routes>
    )
}

export default Approutes
